import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

const EditBreak = ({
  selectedBreak,
  showEditBreakModal,
  handleEditBreakModalDisplay,
  handleEditBreak,
}) => (
  <Modal
    show={showEditBreakModal}
    onHide={() => {
      handleEditBreakModalDisplay(false);
    }}
    centered
  >
    <Modal.Header>
      <Modal.Title className="m-0">Edit Break</Modal.Title>
      <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={() => {
          handleEditBreakModalDisplay(false);
        }}
      />
    </Modal.Header>
    <Formik
      enableReinitialize
      initialValues={{
        breakId: selectedBreak._id,
        breakName: selectedBreak.name,
        shortCode: selectedBreak.shortCode,
        billable: selectedBreak.billable,
      }}
      validationSchema={Yup.object({
        breakName: Yup.string().required('Enter break name'),
        shortCode: Yup.string().max(
          5,
          'Short code must be 5 characters or less'
        ),
      })}
      onSubmit={(values) => {
        handleEditBreak(values);
      }}
    >
      {(formikprops) => (
        <Form onSubmit={formikprops.handleSubmit}>
          <Modal.Body>
            <section>
              <Form.Group controlId="breakName">
                <Form.Label>Break name</Form.Label>
                <Field
                  className="form-control"
                  type="text"
                  placeholder="Enter break name"
                  name="breakName"
                />
                <ErrorMessage
                  name="breakName"
                  render={(msg) => <small className="text-danger">{msg}</small>}
                />
              </Form.Group>
              <Form.Group controlId="shortCode">
                <Form.Label>
                  Short Code <span className="text-muted">(max 5 char)</span>
                </Form.Label>
                <Field
                  className="form-control"
                  type="text"
                  placeholder="Enter short code"
                  name="shortCode"
                />
                <ErrorMessage
                  name="shortCode"
                  render={(msg) => <small className="text-danger">{msg}</small>}
                />
              </Form.Group>
              {/* 
              <Form.Group>
                <label htmlFor="billable">
                  <input
                    className="form-check-input form-check-border mt-1 me-2"
                    type="checkbox"
                    value=""
                    aria-label="Checkbox for following text input"
                    name="billable"
                    onChange={(e) => {
                      formikprops.setFieldValue(
                        'billable',
                        !formikprops.values.billable
                      );
                    }}
                    checked={formikprops.values.billable}
                  />
                  Productive
                </label>
              </Form.Group>
              */}
            </section>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button
              variant="link"
              onClick={() => {
                handleEditBreakModalDisplay(false);
              }}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Update
            </Button>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  </Modal>
);

EditBreak.propTypes = {
  selectedBreak: PropTypes.object,
  showEditBreakModal: PropTypes.bool,
  handleEditBreakModalDisplay: PropTypes.func,
  handleEditBreak: PropTypes.func,
};

export default EditBreak;
